module.exports = __webpack_public_path__ + "img/home-popup-title5.9ef9976c.png";